var map = {
	"./": 438,
	"./1INCH.svg": 1403,
	"./AAVE.svg": 1404,
	"./ADA.svg": 1405,
	"./AKRO.svg": 1406,
	"./ALGO.svg": 1407,
	"./ALPHA.svg": 1408,
	"./ANKR.svg": 1409,
	"./ANT.svg": 1410,
	"./AR.svg": 1411,
	"./ASA.svg": 1412,
	"./ATOM.svg": 1413,
	"./AVAX.svg": 1414,
	"./BAKE.svg": 1415,
	"./BAL.svg": 1416,
	"./BAT.svg": 1417,
	"./BCD.svg": 1418,
	"./BCN.svg": 1419,
	"./BELT.svg": 1420,
	"./BHC.svg": 1421,
	"./BNB.svg": 1422,
	"./BNT.svg": 1423,
	"./BTC.svg": 1424,
	"./BTG.svg": 1425,
	"./BTM.svg": 1426,
	"./BTT.svg": 1427,
	"./BUSD.svg": 1428,
	"./BUSDT.svg": 1429,
	"./CAKE.svg": 1430,
	"./CEL.svg": 1431,
	"./CELO.svg": 1432,
	"./CHSB.svg": 1433,
	"./CHZ.svg": 1434,
	"./CKB.svg": 1435,
	"./COMP.svg": 1436,
	"./CRV.svg": 1437,
	"./DAI.svg": 1438,
	"./DASH.svg": 1439,
	"./DBC.svg": 1440,
	"./DCR.svg": 1441,
	"./DENT.svg": 1442,
	"./DGB.svg": 1443,
	"./DOGE.svg": 1444,
	"./DOT.svg": 1445,
	"./EGLD.svg": 1446,
	"./ELA.svg": 1447,
	"./ENJ.svg": 1448,
	"./EOS.svg": 1449,
	"./ETC.svg": 1450,
	"./ETH.svg": 439,
	"./EWT.svg": 1451,
	"./FET.svg": 1452,
	"./FIL.svg": 1453,
	"./FLM.svg": 1454,
	"./FLOW.svg": 1455,
	"./FTM.svg": 1456,
	"./FTT.svg": 1457,
	"./GAS.svg": 1458,
	"./GRT.svg": 1459,
	"./GT.svg": 1460,
	"./HBAR.svg": 1461,
	"./HELMET.svg": 1462,
	"./HNT.svg": 1463,
	"./HOT.svg": 1464,
	"./HT.svg": 1465,
	"./HUSD.svg": 1466,
	"./ICP.svg": 1467,
	"./ICX.svg": 1468,
	"./INJ.svg": 1469,
	"./IOST.svg": 1470,
	"./IOTX.svg": 1471,
	"./KCS.svg": 1472,
	"./KLAY.svg": 1473,
	"./KMD.svg": 1474,
	"./KNC.svg": 1475,
	"./KSM.svg": 1476,
	"./LEO.svg": 1477,
	"./LET.svg": 1478,
	"./LINK.svg": 1479,
	"./LOOM.svg": 1480,
	"./LPT.svg": 1481,
	"./LRC.svg": 1482,
	"./LSK.svg": 1483,
	"./LTC.svg": 1484,
	"./LUNA.svg": 1485,
	"./MANA.svg": 1486,
	"./MATIC.svg": 1487,
	"./MIOTA.svg": 1488,
	"./MKR.svg": 1489,
	"./NANO.svg": 1490,
	"./NAS.svg": 1491,
	"./NEAR.svg": 1492,
	"./NEO.svg": 440,
	"./NEX.svg": 1493,
	"./NEXO.svg": 1494,
	"./NPXS.svg": 1495,
	"./OCEAN.svg": 1496,
	"./OKB.svg": 1497,
	"./OMG.svg": 1498,
	"./OMG_2.svg": 1499,
	"./ONE.svg": 1500,
	"./ONT.svg": 1501,
	"./PAX.svg": 1502,
	"./POLY.svg": 1503,
	"./QKC.svg": 1504,
	"./QNT.svg": 1505,
	"./QTUM.svg": 1506,
	"./REN.svg": 1507,
	"./REP.svg": 1508,
	"./REV.svg": 1509,
	"./RLC.svg": 1510,
	"./RSR.svg": 1511,
	"./RUNE.svg": 1512,
	"./RVN.svg": 1513,
	"./SC.svg": 1514,
	"./SHIB.svg": 1515,
	"./SNX.svg": 1516,
	"./SOL.svg": 1517,
	"./STEEM.svg": 1518,
	"./STRAX.svg": 1519,
	"./STX.svg": 1520,
	"./SUSHI.svg": 1521,
	"./SWTH.svg": 441,
	"./TEL.svg": 1522,
	"./TFUEL.svg": 1523,
	"./THETA.svg": 1524,
	"./TOMO.svg": 1525,
	"./TRB.svg": 1526,
	"./TRU.svg": 1527,
	"./TRX.svg": 1528,
	"./TTT.svg": 1529,
	"./TUSD.svg": 1530,
	"./UBQ.svg": 1531,
	"./UNA.svg": 1532,
	"./UNI.svg": 1533,
	"./USD.svg": 1534,
	"./USDC.svg": 1535,
	"./USDT.svg": 1536,
	"./UST.svg": 1537,
	"./VET.svg": 1538,
	"./WAVE.svg": 1539,
	"./WBTC.svg": 1540,
	"./XDC.svg": 1541,
	"./XEM.svg": 1542,
	"./XLM.svg": 1543,
	"./XMR.svg": 1544,
	"./XRP.svg": 1545,
	"./XTZ.svg": 1546,
	"./XVG.svg": 1547,
	"./XVS.svg": 1548,
	"./YAM.svg": 1549,
	"./YFI.svg": 1550,
	"./ZEC.svg": 1551,
	"./ZEN.svg": 1552,
	"./ZIL.svg": 1553,
	"./ZRX.svg": 1554,
	"./iUSD.svg": 1555,
	"./index": 438,
	"./index.ts": 438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1402;